exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".permissions[data-v-9f0c2370]{display:flex;align-items:center;min-height:1.5em}", ""]);

